import React from 'react';
import "../styles/signature.css";

function Signature(){

    return(
        <div className="signature-wrapper">
            <p>Designed & developed by</p>
            <p className="name">Eliran Buskila - Web Developer</p>
        </div>
    )
}

export default Signature;